import VectorProps from "./VectorProps";

export default function Upload(props: VectorProps) {
  const {
    className = "",
    fill = "currentColor",
    handleClick = () => null,
    height,
    width,
  } = props;
  // from https://www.figma.com/design/LyX9wbSKd81UvXFeq58wMx/Foodsteps-Design-Library?node-id=1501-1661&t=dRoMlOCnGMXt7u2O-0
  return (
    <svg
      className={className}
      fill={fill}
      height={height ?? width}
      onClick={handleClick}
      viewBox="0 0 20 20"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_24289_891)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.00156 13.1001C1.49862 13.1001 1.90156 13.5031 1.90156 14.0001V17.2001C1.90156 17.6972 2.30451 18.1001 2.80156 18.1001H17.2016C17.6986 18.1001 18.1016 17.6972 18.1016 17.2001V14.0001C18.1016 13.5031 18.5045 13.1001 19.0016 13.1001C19.4986 13.1001 19.9016 13.5031 19.9016 14.0001V17.2001C19.9016 18.6913 18.6927 19.9001 17.2016 19.9001H2.80156C1.31039 19.9001 0.101562 18.6913 0.101562 17.2001V14.0001C0.101562 13.5031 0.504506 13.1001 1.00156 13.1001Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0016 14.9001C9.50455 14.9001 9.1016 14.4972 9.1016 14.0001V2.0001C9.1016 1.50304 9.50455 1.1001 10.0016 1.1001C10.4987 1.1001 10.9016 1.50304 10.9016 2.0001V14.0001C10.9016 14.4972 10.4987 14.9001 10.0016 14.9001Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.1743 5.59803C14.844 5.96953 14.2752 6.00299 13.9037 5.67277L10.0016 2.20426L6.09953 5.67277C5.72803 6.00299 5.15916 5.96953 4.82893 5.59803C4.49871 5.22652 4.53217 4.65766 4.90368 4.32743L9.40367 0.327429C9.74467 0.0243205 10.2585 0.0243205 10.5995 0.327429L15.0995 4.32743C15.471 4.65766 15.5045 5.22652 15.1743 5.59803Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_24289_891">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
